import {
  TTabKey,
} from './audit-trail.ts';

const tabs: Record<TTabKey, string> = {
  settings: 'Settings',
  events: 'Events',
};

export default {
  tabs,
};
